import config from "@Config/index";
import { AppThunk } from "@Store/index";
import axios from "axios";
import {
  fetchBookFormPageDataIfNeeded,
  updateLeadData,
  updatePaymentInfo,
  updatePriceSummary,
  updateTokenPaymentData,
} from "./bookFormReducer";
import { getMetaSuccess, updateProviderId } from "@App/appReducer";
import { getParsedSessionStorageData } from "@Pages/Payment/components/PaymentSummary/utils/utils";
import { FORM_KEYS } from "constants/index";
import getPaymentSummary from "@Utils/getPaymentSummary";

const fetchLead = async (leadUUID: string) => {
  try {
    const leadData = await axios(`${config.API_URL}/api/v0/leads/${leadUUID}`, {
      params: {
        methods: "forms_present,inventory_root",
      },
    });
    return leadData?.data?.data;
  } catch {
    return {};
  }
};

export const fetchPayment = async (token: string, userCurrency = "") => {
  try {
    if (token) {
      const paymentData = await axios(`${config.API_URL}/api/v0/payments/${token}`, {
        params: {
          methods: "inventory_root,form_uuid,fetch_payment_info",
          cache: false,
          ...(userCurrency ? { user_currency: userCurrency } : {}),
        },
        withCredentials: true,
      });
      return paymentData?.data?.data;
    }
    return { err: "token not found" };
  } catch (err) {
    return { err: JSON.stringify(err) };
  }
};

export const loadPaymentSuccessData = (props: any) => async (dispatch: any, getState: any) => {
  let token = "";
  let leadUUID = "";
  let inventory_id = "";
  if (__CLIENT__) {
    const queryParams = new URLSearchParams(window.location.search);
    token = queryParams.get("token") || "";
    leadUUID = queryParams.get("lead_uuid") || "";
    inventory_id = queryParams.get("inventory_id") || "";
  } else {
    token = props.req.query.token;
    leadUUID = props.req.query.lead_uuid;
    inventory_id = props.req.query.inventory_id || "";
  }
  const userCurrency = getState()?.appData?.user_currency;
  const paymentData = await fetchPayment(token, userCurrency);
  let leadData = null;

  dispatch(
    updateTokenPaymentData({
      data: paymentData,
      token,
      err: JSON.stringify(paymentData?.err),
    }),
  );

  if (paymentData?.fetch_payment_info) {
    dispatch(updatePaymentInfo({ payment_info: paymentData?.fetch_payment_info }));
    dispatch(
      updatePriceSummary({
        ...getPaymentSummary(paymentData?.fetch_payment_info),
        payment_info: paymentData?.fetch_payment_info,
      }),
    );
  }

  if (leadUUID) {
    leadData = await fetchLead(leadUUID);
    dispatch(updateLeadData(leadData));
  }

  const meta: any = {};
  if (paymentData) {
    meta.title_prefix = "Payment Complete";
    meta.index = false;
  }

  dispatch(getMetaSuccess(meta));
  dispatch(updateProviderId({ providerId: `${paymentData?.inventory_root?.provider_id}` }));

  const getPaymentDetailsInventoryId = () => {
    const paymentDetails: any = getParsedSessionStorageData(FORM_KEYS.PAYMENT_DETAILS);
    return paymentDetails?.inventory_root_id || "";
  };

  return dispatch(
    fetchBookFormPageDataIfNeeded(
      props,
      paymentData?.inventory_root?.canonical_name ||
        paymentData?.inventory_root_id ||
        inventory_id ||
        leadData?.inventory_root_id ||
        getPaymentDetailsInventoryId(),
      true,
    ),
  );
};

const loadData = (props: any): AppThunk[] => [
  loadPaymentSuccessData(props),
  // More pre-fetched actions...
];

export default loadData;
